import { render, staticRenderFns } from "./BaseMitReserveEdit.vue?vue&type=template&id=0c228c83&scoped=true"
import script from "./BaseMitReserveEdit.vue?vue&type=script&lang=js"
export * from "./BaseMitReserveEdit.vue?vue&type=script&lang=js"
import style0 from "./BaseMitReserveEdit.vue?vue&type=style&index=0&id=0c228c83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c228c83",
  null
  
)

export default component.exports